module.exports = __webpack_public_path__ + "static/img/banner-swiper3.be622c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-swiper3.jpg
// module id = NBkV
// module chunks = 21